// src/App.js

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PhoneAuth from './components/PhoneAuth'; // Fixed case sensitivity
import Dashboard from './components/Dashboard';
import './App.css'; // Make sure to add your styles

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<PhoneAuth />} />
          <Route path="/dashboard" element={<Dashboard />} />
          {/* Other routes */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;